module.exports = __webpack_public_path__ + "media/icons/empty_diagram-76c81c9f.svg";